import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ModalController } from '@ionic/angular';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { EmailpopupComponent } from '../email/emailpopup/emailpopup.component';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ENTITY_NAMES, ORGANIZATION_TYPES, RECORD_STATUS_VALUES } from 'src/app/modules/shared/constants/api-constants';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';


@Component({
  selector: 'app-itinerary-details',
  templateUrl: './itinerary-details.component.html',
  styleUrls: ['./itinerary-details.component.scss'],
})
export class ItineraryDetailsComponent implements OnInit {

  @Input() itineraryId: any;
  @Input() leadId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() assignItineraryId: EventEmitter<string> = new EventEmitter<string>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter();

  @Output() totalDaysChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() totalGuestsChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() destinationChanges: EventEmitter<boolean> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();
  @Output() updateInventoryItinerary: EventEmitter<void> = new EventEmitter();

  @Input() storedFormData: any;
  @Input() editInventory: boolean = false;
  @Input() editQuote: boolean = false;

  @Input() serviceBasedSections: any;

  showRecommendedItineraries: boolean = false;
  showRecommendedDmcVendors: boolean = false;
  showWebsiteSettings: boolean = false;

  tempRecommendedItineraryId: any;
  tempRecommendedOrganizationId: any;
  recommendedItineraryType: any;
  recommendedOrganizationId: any;
  recommendedDestinations: any;
  useRecommendedItinerary: boolean = false;

  selectedInventoryItineraryId: any;
  selectedInventoryOrganizationId: any;

  totalNoOfNights: number = 0;

  itineraryDetailsForm!: FormGroup;

  recommenedItinerariesData: any = [];

  // LOVs
  accommodationType: any;

  daysChanged: boolean = false;
  guestsChanged: boolean = false;
  destinationsChanged: boolean = false;

  allVendorsData: any = {
    data: [],
  };
  originalmailsdata: any;

  selectAll: boolean = false;
  isdisabled: boolean = false;
  selectedVendors: string[] = [];
  dmcSelectAll: boolean = false;
  clientId: any;

  constructor(
    private _leadService: LeadsService,
    private _fb: FormBuilder,
    private _itineraryService: ItineraryService,
    private _inventoryService: InventoryService,
    public _globalService: GlobalService,
    private _modalController: ModalController,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _validationService: InputValidationsService,
    private _contactService: ContactsService,
    private _lovDataService: LovDataService
  ) {

  }

  ngOnInit() {
    // Initialization of form
    this.itineraryDetailsForm = this._fb.group({
      itineraryName: ['', [Validators.required, this._validationService.maxLengthValidator(35)]],
      destinationDaysArray: this._fb.array([this.createDestinationItem()]),
      noOfGuests: [{}, [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: [{ value: '', disabled: true }, [Validators.required]],
      sectionNote: [''],
      flexibleDays: [false],
      hotelType: [''],
      noOfRooms: [0],
      budget: [''],
      dmcVendorSearch: [''],
      showInWebsite: [false],
      imagePath: [""],
      imageDoc: [null],
      itineraryCost: this._fb.control(
        { amount: null, currency: 'INR' },
        [this.costValidator]
      ),
      itineraryType: ['domestic'],

    });

    this.itineraryDetailsForm.valueChanges.subscribe(() => {
      this.itineraryDetailsForm.markAsTouched();
    })

    if (this.storedFormData) {
      this.totalNoOfNights = this.storedFormData.totalDays;
      if (this.storedFormData.inventoryItineraryId) {
        this.selectedInventoryItineraryId = this.storedFormData.inventoryItineraryId;
      } else if (this.storedFormData.packageId) {
        this.selectedInventoryItineraryId = this.storedFormData.packageId;
        this.selectedInventoryOrganizationId = this.storedFormData.recommendedOrganizationId;
      }

      this.itineraryDetailsForm.patchValue({
        itineraryName: this.storedFormData.itineraryName,
        destination: this.patchDestinationsDays(this.storedFormData.destination),
        startDate: this.storedFormData.startDate ? this.convertToDate(this.storedFormData.startDate) : null,
        endDate: this.storedFormData.endDate ? this.convertToDate(this.storedFormData.endDate) : null,
        noOfGuests: {
          noOfAdults: this.storedFormData.totalAdults,
          noOfChildren: this.storedFormData.totalChildrens,
          noOfInfants: this.storedFormData.totalInfants,
        },
        flexibleDays: this.storedFormData.flexibleDays,
        hotelType: this.storedFormData.hotelType,
        noOfRooms: this.storedFormData.noOfRooms,
        budget: this.storedFormData.budget,
        sectionNote: this.storedFormData.note,
        showInWebsite: this.storedFormData.showInWebsite,
        imagePath: this.storedFormData.imagePath,
        imageDoc: this.storedFormData.imagePath,
        itineraryType: this.storedFormData.itineraryType || "domestic",
        // itineraryCost: this.storedFormData.approxCost,
        itineraryCost: this.parseApproxCost(this.storedFormData?.approxCost)

      })
      this.getRecommendedItinerarires();

      this.itineraryDetailsForm.markAsPristine();
      if (this.storedFormData.dataInvalid) {
        this.itineraryDetailsForm.markAllAsTouched();
      }

    }

    // LOv
    this._lovDataService.getLovData("HotelType").subscribe((data) => {
      if (data) {
        this.accommodationType = data;
      }
    });

    if (!this.leadId) {
      // If craeting invetnory itienrary then removing following proprties
      this.itineraryDetailsForm.removeControl('noOfGuests');
      this.itineraryDetailsForm.removeControl('startDate');
      this.itineraryDetailsForm.removeControl('endDate');
    } else {
      // if createing quote, removing website related settings.
      this.itineraryDetailsForm.removeControl('showInWebsite');
      this.itineraryDetailsForm.removeControl('imageDoc');
      this.itineraryDetailsForm.removeControl('imagePath');
      this.itineraryDetailsForm.removeControl('itineraryType');
      this.itineraryDetailsForm.removeControl('itineraryCost');

    }

    if (this.serviceBasedSections?.showRouteCraft) {
      this.showRecommendedItineraries = this.leadId && !this.editInventory;
    } else {
      this.showRecommendedItineraries = false;
    }
    this.showRecommendedDmcVendors = this.leadId && !this.editInventory;

    this.showWebsiteSettings = !this.leadId;

    // Subscribe to value change
    this.itineraryDetailsForm.get('destinationDaysArray')?.valueChanges.subscribe(value => {
      // when the destinationDaysArray changes, get recommended itineraries
      this.getRecommendedItinerarires();

      // Calculate total days based on the destinationDaysArray
      let totalDays: number = 0;
      for (let item of value) {
        totalDays += +item.days;
      }
      this.totalNoOfNights = totalDays;

      // When no of days changes, update the end date
      this.updateEndDate()
    });

    this.itineraryDetailsForm.get('startDate')?.valueChanges.subscribe(startDate => {
      this.updateEndDate();
      this.getRecommendedItinerarires();
    });

    this.updateValidationForWebsiteSettings();
    this.itineraryDetailsForm.get('showInWebsite')?.valueChanges.subscribe(value => {
      this.updateValidationForWebsiteSettings();
    });

    if (this.storedFormData) {
      let lastDestination = this.storedFormData.destination[this.storedFormData.destination.length - 1];
      this.VendorDmcsemails(lastDestination.location, true);
    } else {
      this.VendorDmcsemails(null, true);
    }
    this._reloadService.reloadVendorDmcsInPopup$.subscribe(() => {
      if (this.storedFormData) {
        let lastDestination = this.storedFormData.destination[this.storedFormData.destination.length - 1];
        this.VendorDmcsemails(lastDestination.location, true);
      } else {
        this.VendorDmcsemails(null, true);
      }
    })
  }

  costValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Handle null / wrong type
    if (!value || typeof value !== 'object') {
      return { required: true };
    }

    // Validate amount specifically
    if (value.amount == null || value.amount === '') {
      return { required: true };
    }

    return null; // valid
  };



  private parseApproxCost(approx: any): { amount: number | null; currency: string } {
    const fallback = { amount: null, currency: 'INR' };
    if (!approx) return fallback;

    if (typeof approx === 'object') {
      return { amount: approx.amount ?? null, currency: approx.currency ?? fallback.currency };
    }

    const text = String(approx).trim();
    const numMatch = text.match(/[\d,\.]+/);
    const codeMatch = text.match(/\b[A-Z]{3}\b/); // ISO like INR

    const amount = numMatch ? Number(numMatch[0].replace(/,/g, '')) : null;
    const currency = codeMatch ? codeMatch[0] : fallback.currency;
    return { amount, currency };
  }


  ngOnChanges() {
    this.ngOnInit()
  }

  ngAfterViewInit() {
  }


  today(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }
  convertToDate(value: any): any {
    if (!value) {
      return null;
    }
    return new Date(value);
  }

  get destinationDaysArray(): FormArray {
    return this.itineraryDetailsForm.get('destinationDaysArray') as FormArray;
  }

  createDestinationItem(): FormGroup {
    return this._fb.group({
      location: ['', Validators.required],
      days: [0, this._validationService.valueNotZeroValidator()]
    });
  }

  patchDestinationsDays(storedDestinationsData: any) {
    const destinationsArray = this.destinationDaysArray;
    storedDestinationsData.forEach((destinationDays: any, index: number) => {
      if (destinationsArray.length <= index) {
        destinationsArray.push(this.createDestinationItem());
      }
      destinationsArray.at(index).patchValue({
        location: destinationDays.location,
        days: destinationDays.days
      });
    });
  }

  addDestination() {
    this.destinationDaysArray.push(this.createDestinationItem());
  }

  removeDestination(index: number) {
    this.destinationDaysArray.removeAt(index);
    this.itineraryDetailsForm.markAsDirty();
    this.itineraryDetailsForm.markAsTouched();
  }

  private updateEndDate(): void {
    const startDate = this.itineraryDetailsForm.get('startDate')?.value;

    if (startDate && this.totalNoOfNights) {
      const startDateFormat: Date = new Date(startDate);

      const endDate = new Date(startDateFormat);
      endDate.setDate(startDateFormat.getDate() + this.totalNoOfNights);

      this.itineraryDetailsForm.get('endDate')?.setValue(endDate, { emitEvent: false });
    }
  }

  get getTotalNightsAndDays() {
    let totalNoOfNights = Number(this.totalNoOfNights);
    return `${totalNoOfNights} Nights / ${totalNoOfNights + 1} Days`
  }


  //////////////////////////
  async onSubmit(goNext: boolean = false): Promise<boolean> {
    if (!this.itineraryDetailsForm.valid) {
      this.itineraryDetailsForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }

    const formData = await this.serializeFormData(this.itineraryDetailsForm.getRawValue());

    // Handle when the itinerary is added to lead-specific
    if (this.leadId) {
      return this.handleLeadSpecificSubmission(formData, goNext);
    }

    // Handle when the itinerary is added to inventory
    return this.handleInventorySubmission(formData);
  }

  private async handleLeadSpecificSubmission(formData: any, goNext: boolean): Promise<boolean> {
    if (this.useRecommendedItinerary) {
      this._itineraryService.selectRecommendedItinerary(this.recommendedItineraryType, formData).subscribe({
        next: async (data) => {
          await this._modalPopupService.closeAllModals();
          let nextTargetTab: any;
          if (goNext) {
            if (this.recommendedItineraryType === ENTITY_NAMES.DMC_PACKAGE) {
              nextTargetTab = "dmcPackage"
            } else {
              if (this.serviceBasedSections.showRouteCraft || this.serviceBasedSections.showTourPackage) {
                nextTargetTab = "route";
              } else if (this.serviceBasedSections.showHotels) {
                nextTargetTab = "accommodation";
              } else if (this.serviceBasedSections.showTransportation || this.serviceBasedSections.showTransfers) {
                nextTargetTab = "transportation";
              }
            }
          } else {
            nextTargetTab = null;
          }

          await this._modalPopupService.openItineraryForm(this.clientId, this.leadId, data.itineraryDetails?.itineraryId, null, null, null, nextTargetTab);
          this._reloadService.triggerQuotesReload();
          this._reloadService.triggerTravelPrefReload();
        },
        error: (error) => {
          console.error("Error selecting recommended itinerary", error);
        }
      })

    } else {
      if (this.editQuote) {
        this.finalizeFormSubmission(formData);
        this.emitChanges();
        this.updateQuote.emit();
        return true;
      }
      const data = await this._itineraryService.addItineraryDetails(formData).toPromise();
      this._responseNotificationService.showMessage("Travel Preference Added!");
      this.finalizeFormSubmission(data);
      this.assignItineraryId.emit(data.itineraryId);
      this.emitChanges();
    }

    this._reloadService.triggerQuotesReload();
    this._reloadService.triggerTravelPrefReload();
    return true;
  }

  private async handleInventorySubmission(formData: any): Promise<boolean> {
    if (this.editInventory) {
      this.finalizeFormSubmission(formData);
      this.emitChanges();
      this.assignItineraryId.emit(formData.itineraryId);
      this.updateInventoryItinerary.emit();
      return true;
    }

    try {
      const data = await this._inventoryService.addInventoryItineraryDetails(formData).toPromise();
      this._responseNotificationService.showMessage("Travel Preference Added!");
      this.finalizeFormSubmission(data);
      console.log("Itinerary data", data);
      this.emitChanges();
      this.assignItineraryId.emit(data.itineraryId);
      this._reloadService.triggerInventoryItineraryReload();
      return true;
    } catch (error) {
      console.error("Error adding inventory itinerary details", error);
      return false;
    }
  }

  private emitChanges(): void {
    if (this.daysChanged) {
      this.totalDaysChanges.emit();
    }
    if (this.guestsChanged) {
      this.totalGuestsChanges.emit();
    }
    if (this.destinationsChanged) {
      this.destinationChanges.emit();
    }
  }

  private finalizeFormSubmission(data: any): void {
    this.itineraryDetailsForm.markAsPristine();
    data.dataSaved = true;
    this.storedFormData = data;
    this.storeFormData.emit(data);
  }



  ///////////////////////////

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }


  private async serializeFormData(formData: any) {
    let serializedData = {
      itineraryName: formData.itineraryName,
      destination: formData.destinationDaysArray.filter((item: any) => item.location !== "" && item.days > 0).map((item: any) => ({
        location: item.location,
        days: item.days
      })),
      totalDays: this.totalNoOfNights,
      startDate: formData.startDate ? this._globalService.convertTripDateToString(this.convertToDate(formData.startDate)) : null,
      endDate: formData.endDate ? this._globalService.convertTripDateToString(this.convertToDate(formData.endDate)) : null,
      totalAdults: formData.noOfGuests ? formData.noOfGuests.noOfAdults : '',
      totalChildrens: formData.noOfGuests ? formData.noOfGuests.noOfChildren : '',
      totalInfants: formData.noOfGuests ? formData.noOfGuests.noOfInfants : '',
      flexibleDays: formData.flexibleDays,
      hotelType: formData.hotelType,
      noOfRooms: formData.noOfRooms,
      budget: formData.budget,
      note: formData.sectionNote,
      leadId: this.leadId,
      clientId: this.clientId,
      organizationId: this.storedFormData?.organizationId,
      status: this.storedFormData ? this.storedFormData.status : RECORD_STATUS_VALUES.DRAFT,
      id: this.storedFormData ? this.storedFormData.id : null,
      ownershipRole: this.storedFormData ? this.storedFormData.ownershipRole : null,
      ownership: this.storedFormData ? this.storedFormData.ownership : null,
      itineraryId: this.storedFormData ? this.storedFormData.itineraryId : null,
      parentItineraryId: this.storedFormData ? this.storedFormData.parentItineraryId : null,
      inventoryItineraryId: this.tempRecommendedItineraryId ? this.tempRecommendedItineraryId : (this.storedFormData?.inventoryItineraryId || null),
      packageId: this.tempRecommendedItineraryId ? this.tempRecommendedItineraryId : (this.storedFormData?.packageId || null),
      recommendedOrganizationId: this.recommendedOrganizationId ? this.recommendedOrganizationId : (this.storedFormData?.recommendedOrganizationId || null),
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      ...(this.storedFormData && { createDate: this.storedFormData.createDate })
    };

    if (this.showWebsiteSettings) {
      serializedData = {
        ...serializedData,
        showInWebsite: formData.showInWebsite,
        imagePath: formData.imagePath,
        // approxCost: formData.itineraryCost
        approxCost: formData.itineraryCost && formData.itineraryCost.amount != null
          ? { amount: formData.itineraryCost.amount, currency: formData.itineraryCost.currency }
          : null,
        itineraryType: formData.itineraryType

      }
    }

    // Checking if days or guests changed
    if (this.storedFormData) {
      if (this.storedFormData.totalDays !== serializedData.totalDays) {
        this.daysChanged = true;
      }
      if (this.storedFormData.totalAdults + this.storedFormData.totalChildrens + this.storedFormData.totalInfants !== serializedData.totalAdults + serializedData.totalChildrens + serializedData.totalInfants) {
        this.guestsChanged = true;
      }
      // Compare only location and days for each destination object
      const getLocationDaysArray = (arr: any[]) =>
        (arr || []).map((item: any) => ({
          location: item.location,
          days: item.days
        }));

      const prevDest = getLocationDaysArray(this.storedFormData.destination);
      const currDest = getLocationDaysArray(serializedData.destination);

      if (JSON.stringify(prevDest) !== JSON.stringify(currDest)) {
        this.destinationsChanged = true;
      }
    }

    // Checking if user changed destination to use recommended itinerary
    if (this.tempRecommendedItineraryId) {
      if (JSON.stringify(this.recommendedDestinations) == JSON.stringify(serializedData.destination)) {
        this.useRecommendedItinerary = true;
      } else {
        serializedData.inventoryItineraryId = null;
        serializedData.packageId = null;
        serializedData.recommendedOrganizationId = null;
      }
    }

    return serializedData;
  }


  // Recommended itinerary

  getRecommendedItinerarires() {
    if (this.showRecommendedItineraries) {
      let data = {
        leadId: this.leadId,
        destination: this.itineraryDetailsForm.get("destinationDaysArray")?.value
          .filter((item: any) => item.location !== "" && item.days > 0)
          .map((item: any) => ({
            location: item.location,
            days: item.days
          })),
        startDate: this.itineraryDetailsForm.get('startDate')?.value ? this._globalService.convertTripDateToString(this.convertToDate(this.itineraryDetailsForm.get('startDate')?.value)) : null,
        endDate: this.itineraryDetailsForm.get('endDate')?.value ? this._globalService.convertTripDateToString(this.convertToDate(this.itineraryDetailsForm.get('endDate')?.value)) : null,
      }

      if (data.destination.length > 0) {
        this._inventoryService.getRecommendedItineraries(data, ORGANIZATION_TYPES.AGENT).subscribe((data) => {
          this.recommenedItinerariesData = data;
        })
      }
    }
  }

  getDestinationsArray(destinations: any[]): string {
    if (!destinations) {
      return '';
    }
    let destinationString = destinations.map((item: any) => this._globalService.getFirstItemOfString(item.location)).join(', ');
    return this._globalService.trimString(destinationString, 10);
  }

  async openInventoryItinerary(itinerary: any) {
    const { itineraryId, type, organizationId } = itinerary;

    const recommendedItinerary = {
      recommendedItineraryId: itineraryId,
      recommendedItineraryType: type === "Itinerary" ? ENTITY_NAMES.INVENTORY_ITINERARY : ENTITY_NAMES.DMC_PACKAGE,
      recommendedOrganizationId: organizationId
    };

    const modalData = type === "Itinerary"
      ? await this._modalPopupService.openInventoryItineraryView(itineraryId, this.leadId, this.clientId)
      : await this._modalPopupService.openDmcPackageReview(itineraryId, this.leadId, organizationId);

    if (modalData?.createQuote) {
      if (this.storedFormData) {
        if (await this._globalService.confirmActionPopup("This action will delete the current data and replace it with new data. Do you want to continue?", "Confirm", "Yes")) {
          await this.selectRecommendedItinerary(recommendedItinerary);
        }
      } else {
        await this.selectRecommendedItinerary(recommendedItinerary);
      }
    }
  }

  async createQuote(itinerary: any) {
    const { itineraryId: recommendedItineraryId, type: recommendedItineraryType, organizationId: recommendedOrganizationId } = itinerary;

    const recommendedItinerary = {
      recommendedItineraryId,
      recommendedItineraryType: recommendedItineraryType === "Itinerary" ? ENTITY_NAMES.INVENTORY_ITINERARY : ENTITY_NAMES.DMC_PACKAGE,
      recommendedOrganizationId
    };

    if (this.storedFormData) {
      if (await this._globalService.confirmActionPopup("This action will delete the current data and replace it with new data. Do you want to continue?", "Confirm", "Yes")) {
        await this.selectRecommendedItinerary(recommendedItinerary);
      }
    } else {
      await this.selectRecommendedItinerary(recommendedItinerary);
    }
  }

  async selectRecommendedItinerary(recommendedItinerary: any) {
    this.itineraryDetailsForm.markAsTouched();
    this.itineraryDetailsForm.markAsDirty();
    this.tempRecommendedItineraryId = recommendedItinerary.recommendedItineraryId;
    this.tempRecommendedOrganizationId = recommendedItinerary.recommendedOrganizationId;
    this.recommendedItineraryType = recommendedItinerary.recommendedItineraryType;
    this.recommendedOrganizationId = recommendedItinerary.recommendedOrganizationId;

    let itineraryDetails: any = await this.serializeFormData(this.itineraryDetailsForm.value);
    this.recommendedDestinations = itineraryDetails.destination;
  }

  unselectRecommendedItinerary() {
    this.itineraryDetailsForm.markAsTouched();
    this.itineraryDetailsForm.markAsDirty();
    this.tempRecommendedItineraryId = null;
    this.tempRecommendedOrganizationId = null;
    this.recommendedItineraryType = null;
    this.recommendedOrganizationId = null;
    this.recommendedDestinations = [];
  }

  checkIfRecommendedItineraryIsSelected(itinerary: any): boolean {
    const type = itinerary.type;
    if (type === "DmcPackage") {
      return (this.tempRecommendedItineraryId || this.selectedInventoryItineraryId) === itinerary?.itineraryId && (this.tempRecommendedOrganizationId || this.selectedInventoryOrganizationId) === itinerary?.organizationId;
    } else {
      return (this.tempRecommendedItineraryId || this.selectedInventoryItineraryId) === itinerary?.itineraryId
    }
  }


  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit(true)) {
      if (this.useRecommendedItinerary) {
        return;
      }
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.itineraryDetailsForm.dirty || this.itineraryDetailsForm.invalid) && this.itineraryDetailsForm.touched;
  }


  storeDataToParent() {
    this.serializeFormData(this.itineraryDetailsForm.value).then(formdata => {
      formdata.dataInvalid = true;
      this.storeFormData.emit(formdata);
      this.viewChange.emit(true);
    })
  }

  get dmcVendorSearch(): any {
    return this.itineraryDetailsForm.get("dmcVendorSearch")?.value;
  }
  searchDmcVendors() {
    const searchValue = (this.dmcVendorSearch || '').trim().toLowerCase();
    if (!this.allVendorsData || !Array.isArray(this.allVendorsData.data)) return;

    if (searchValue === "") {
      // Reload all vendors if search is empty
      this.loadVendorsData();
    } else {
      this.allVendorsData.data = this.allVendorsData.data.filter((vendor: any) =>
        (vendor.organizationName || '').toLowerCase().includes(searchValue)
      );
    }
  }
  handlePrediction(event: any) {
    this.VendorDmcsemails(event);
  }
  async VendorDmcsemails(searchValue: any = null, requested: boolean | null = null) {
    if (this.showRecommendedDmcVendors) {
      this.originalmailsdata = await this.getLeadEmailHistory(this.leadId);
      this.loadVendorsData(searchValue, requested);
    }
  }

  async getLeadEmailHistory(leadId: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._leadService.getLead(leadId).subscribe({
        next: (data) => {
          let emails = data?.vendorDmcMailData;
          resolve(emails);
        }, error: (err) => {
          console.error(err);
          reject(err);
        }
      })
    })
  }

  loadVendorsData(searchValue: any = null, requested: boolean | null = null) {
    if (!searchValue) {
      let lastDestination = this.storedFormData?.destination[this.storedFormData?.destination?.length - 1];
      searchValue = lastDestination?.location || "";
    }
    if (searchValue !== "" && searchValue !== null) {
      this._contactService.getVendoranddmcsContacts(-1, -1, searchValue).subscribe((data) => {
        let filteredData = data.data.map((vendor: any) => {
          let isRequested = false;

          // Check if vendor ID or DMC ID exists in originalmailsdata
          if (this.originalmailsdata) {
            isRequested = this.originalmailsdata.some((mail: any) => {
              return (
                (mail.vendorIds && mail.vendorIds.includes(vendor.vendorId)) ||
                (mail.dmcIds && mail.dmcIds.includes(vendor.dmcId))
              );
            });
          }

          return {
            ...vendor,
            organizationName: vendor.organizationName,
            email: vendor.email,
            rating: vendor.rating,
            type: vendor.dmcId ? 'DMC' : vendor.vendorId ? 'Vendor' : 'Unknown',
            selected: false,
            request: isRequested, // Set request based on the check
          };
        });
        // if (requested !== null)
        //   filteredData = filteredData.filter((vendor: any) => vendor.request === requested);
        filteredData.sort((a: any, b: any) => Number(b.request) - Number(a.request));
        this.allVendorsData.data = filteredData;
        this.dmcSelectAll = !this.allVendorsData.data.every((vendor: any) => vendor.request === true);
      });
    }
  }


  async sendemail(email: any = null) {
    if (!this.itineraryDetailsForm.valid) {
      this.itineraryDetailsForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false; // No 'await' here
    }
    if (!this.storedFormData) {
      this.onSubmit();
    }

    let selectedEmails: string[] = [];
    let selectedVendors: any[] = [];

    if (email) {
      selectedEmails.push(email); // Push email into the array
      selectedVendors = this.allVendorsData.data.filter((vendor: any) => vendor.email == email);
    } else {
      selectedVendors = this.allVendorsData.data.filter(
        (vendor: any) => vendor.selected && vendor.request === false
      );
      selectedEmails = selectedVendors.map((vendor: any) => vendor.email); // Extract emails from vendors
    }

    const selectedVendorIds = selectedVendors
      .filter((vendor: any) => vendor.vendorId) // Only vendors
      .map((vendor: any) => vendor.vendorId);

    const selectedDmcIds = selectedVendors
      .filter((vendor: any) => vendor.dmcId) // Only DMCs
      .map((vendor: any) => vendor.dmcId);
    const modal = await this._modalController.create({
      component: EmailpopupComponent,
      componentProps: {
        emails: selectedEmails,
        selectedVendorIds: selectedVendorIds, // Send Vendor IDs separately
        selectedDmcIds: selectedDmcIds, // Send DMC IDs separately
        leadId: this.leadId,
        itineraryDetails: this.itineraryDetailsForm.getRawValue(),
        totalNoOfNights: this.totalNoOfNights
      },
      backdropDismiss: false, // Prevents closing on clicking outside
      cssClass: 'email-modal-popup-css' // Optional: Add custom styling
    });

    return await modal.present();
  }
  toggleSelectAll(event: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked)
      this.isdisabled = true
    else
      this.isdisabled = false

    // this.selectAll = !this.selectAll;
    this.allVendorsData.data.forEach((vendor: any) => {
      vendor.selected = isChecked;
    });
  }

  updateselection(id: any, event: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.allVendorsData.data.forEach((v: any) => {
      if (v.id === id) {
        v.selected = isChecked;
      }
    });
    // Count the number of selected vendors
    const selectedCount = this.allVendorsData.data.filter((v: any) => v.selected).length;

    // Enable the send request button if more than one vendor is selected
    this.isdisabled = selectedCount > 1;
  }




  sendSelectedEmails() {
    if (this.selectedVendors.length === 0) {
      alert("No vendors selected");
      return;
    }
  }

  getImgUrl(file: any) {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      return fileURL;
    } else {
      return file;
    }
  }

  deleteBannerImage() {
    this.itineraryDetailsForm.get('imagePath')?.setValue(null);
    this.itineraryDetailsForm.get('imageDoc')?.setValue(null);
    this.itineraryDetailsForm.markAsDirty();
  }

  onBannerChange(event: any) {
    const file = event.target.files[0];
    // Checking if image is more than 5MB
    if (file.size > 5 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
      return;
    }

    if (file) {
      const formData = new FormData();
      formData.append('image', file);
      this._lovDataService.uploadImage(formData, "website").subscribe({
        next: (res) => {
          this.itineraryDetailsForm.get('imagePath')?.setValue(res);
          this.itineraryDetailsForm.get('imageDoc')?.setValue(file);
          this.itineraryDetailsForm.markAsDirty();
        },
        error: (error) => {
          console.error('Error uploading image: ', error);
          this._responseNotificationService.showMessage("Error uploading image", true);
        }
      })
    }
  }

  updateValidationForWebsiteSettings() {
    const itineraryCostCtrl = this.itineraryDetailsForm.get("itineraryCost");
    if (this.itineraryDetailsForm.get("showInWebsite")?.value && this.showWebsiteSettings) {
      this.itineraryDetailsForm.get("imageDoc")?.setValidators([Validators.required]);
      itineraryCostCtrl?.setValidators([this.costValidator]);
      this.itineraryDetailsForm.get("itineraryType")?.setValidators([Validators.required]);
    } else {
      this.itineraryDetailsForm.get("imageDoc")?.setValidators([]);
      itineraryCostCtrl?.clearValidators();
      this.itineraryDetailsForm.get("itineraryType")?.setValidators([]);
    }
    this.itineraryDetailsForm.get("imageDoc")?.updateValueAndValidity();
    itineraryCostCtrl?.updateValueAndValidity();
    this.itineraryDetailsForm.get("itineraryType")?.updateValueAndValidity();
  }
}
